import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Lumen OS is the single design system — these types are kept so the existing
// Settings UI (theme toggle) doesn't break, but applyTheme is intentionally a
// no-op: tokens live in client/src/index.css under :root.

export type ThemePreference = 'light' | 'dark' | 'auto';
export type Theme = 'light' | 'dark';

function resolveTheme(_pref: ThemePreference): Theme {
  return 'light';
}

interface ThemeState {
  preference: ThemePreference;
  theme: Theme;
  setPreference: (p: ThemePreference) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      preference: 'light',
      theme: 'light',
      setPreference: (preference) => {
        const theme = resolveTheme(preference);
        set({ preference, theme });
        applyTheme(theme);
      },
    }),
    {
      name: 'axis-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyTheme(resolveTheme(state.preference));
      },
    }
  )
);

// Lumen is the only palette — no per-property overrides. We just stamp the
// data-theme attribute so any [data-theme="…"] selectors stay consistent.
export function applyTheme(_theme: Theme) {
  document.documentElement.setAttribute('data-theme', 'light');
}
